import { render } from "./CustomersPartnersComponent.vue?vue&type=template&id=4504a67f&scoped=true"
import script from "./CustomersPartnersComponent.vue?vue&type=script&lang=js"
export * from "./CustomersPartnersComponent.vue?vue&type=script&lang=js"

import "./CustomersPartnersComponent.vue?vue&type=style&index=0&id=4504a67f&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4504a67f"]])

export default __exports__